import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  categoriesIcons: {
    data: [],
    loading: false,
    error: null,
  },
  categories: {
    data: [],
    loading: false,
    error: null,
  },
  selectedCategory: {
    data: {},
    loading: false,
  },
};

export const getCategoriesIcons = createAsyncThunk(
  "categories/getCategoriesIcons",
  async () => {
    try {
      const response = await httpClient.get("/web/categories-icons");
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getCategories = createAsyncThunk(
  "categories/getCategories",
  async () => {
    try {
      const response = await httpClient.get("/web/categories");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (category) => {
    try {
      const response = await httpClient.post("/web/categories", category);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (category) => {
    try {
      const response = await httpClient.put(
        `/web/categories/${category._id}`,
        category
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (id) => {
    try {
      const response = await httpClient.delete(`/web/categories/${id}`);
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getCategoryById = createAsyncThunk(
  "categories/getCategoryById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/categories/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  extraReducers: (builder) =>
    builder
      .addCase(getCategoriesIcons.pending, (state) => {
        state.categoriesIcons.loading = true;
      })
      .addCase(getCategoriesIcons.fulfilled, (state, { payload }) => {
        state.categoriesIcons.loading = false;
        state.categoriesIcons.data = payload.res;
      })
      .addCase(getCategoriesIcons.rejected, (state, { error }) => {
        state.categoriesIcons.loading = false;
        state.categoriesIcons.error = error.message;
      })
      .addCase(addCategory.pending, (state) => {
        state.categories.loading = true;
      })
      .addCase(addCategory.fulfilled, (state, { payload }) => {
        state.categories.loading = false;
        state.categories.data.push(payload);
      })
      .addCase(addCategory.rejected, (state, { error }) => {
        state.categories.loading = false;
        state.categories.error = error.message;
      })
      .addCase(updateCategory.pending, (state) => {
        state.categories.loading = true;
      })
      .addCase(updateCategory.fulfilled, (state, { payload }) => {
        state.categories.loading = false;
        state.categories.data = state.categories.data.map((category) =>
          category._id === payload._id ? payload : category
        );
      })
      .addCase(updateCategory.rejected, (state, { error }) => {
        state.categories.loading = false;
        state.categories.error = error.message;
      })
      .addCase(deleteCategory.pending, (state) => {
        state.categories.loading = true;
      })
      .addCase(deleteCategory.fulfilled, (state, { payload }) => {
        state.categories.loading = false;
        state.categories.data = state.categories.data.filter(
          (category) => category._id !== payload.res._id
        );
      })
      .addCase(deleteCategory.rejected, (state, { error }) => {
        state.categories.loading = false;
        state.categories.error = error.message;
      })
      .addCase(getCategories.pending, (state) => {
        state.categories.loading = true;
      })
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories.loading = false;
        state.categories.data = payload;
      })
      .addCase(getCategories.rejected, (state, { error }) => {
        state.categories.loading = false;
        state.categories.error = error.message;
      })
      .addCase(getCategoryById.pending, (state) => {
        state.selectedCategory.loading = true;
      })
      .addCase(getCategoryById.fulfilled, (state, { payload }) => {
        state.selectedCategory.loading = false;
        state.selectedCategory.data = payload;
      })
      .addCase(getCategoryById.rejected, (state, { error }) => {
        state.selectedCategory.loading = false;
        state.selectedCategory.error = error.message;
      }),
});

export default categoriesSlice.reducer;
